<div class="n-breadcrumb d-flex align-items-center justify-content-between">
    <ol class="breadcrumb m-0 bg-transparent p-0">
        <li class="breadcrumb-item"><a href="/#/dealer/home">Home</a></li>
        <li class="breadcrumb-item active">{{pageTitle}}</li>
    </ol>
</div>
<h3 class="mt-2 font-weight-light">{{pageTitle}}</h3>

<div class="tcard">
    <div class="tcard-body p-4">
        <!-- <div class="col-md-12"> -->
            <div class="ui-g" style="width:250px;margin-bottom:10px;flex-wrap: nowrap;">
                <div class="ui-g-12"><p-radioButton name="group2" value="Lexus" label="Lexus" [(ngModel)]="oemType" inputId="preopt1"></p-radioButton></div>
                <div class="ui-g-12"><p-radioButton name="group2" value="Non-Lexus" label="Non-Lexus" [(ngModel)]="oemType" inputId="preopt2"></p-radioButton></div>    
            </div>
            <form class="editdealer-form" novalidate [formGroup]="returnMailerForm">
                <div class="row">
                    <div class="form-group col-md-3">
                        <label>Return Mailer</label>
                        <input type="text" class="form-control" formControlName="returnMailer" placeholder="Return Mailer">
                        <fieldset [hidden]="errorMsgCheck">
                            <p [innerHtml]= 'errorMessage'></p>
                        </fieldset>
                          </div>
                    <div class="btn-footer">
                        <label *ngIf="msgSuccess" style="color: green; margin-right: 15px;">{{Message}} </label>
                        <button type="submit" class="btn btn-primary py-2 px-4" (click)="SubmitReturnMailers()" [disabled]='!returnMailerForm.valid'><i class="la la-check mr-2"></i> Submit</button>
                    </div>
                </div>
            </form>
        </div>
    <!-- </div> -->
</div>
